// @flow
import { get } from 'lodash';
import {
  appInstallNativeExperimentId,
  cisClickToRevealExperimentId
} from 'src/config';

const UPDATE_FEATURE_FLAGS = 'UPDATE_FEATURE_FLAGS';

const experimentsHelper = (
  cookieValue: ?string,
  experimentid: string,
  experiments: Seek$Experiments
): boolean =>
  // Used if the featureFlag is also currently an experiment
  Boolean(cookieValue || get(experiments[experimentid], 'variation.index'));

export default function reducer(state: any = {}, action: any = {}) {
  switch (action.type) {
    case UPDATE_FEATURE_FLAGS: {
      const { dynamicFlags } = action.payload;
      return {
        ...state,
        ...dynamicFlags
      };
    }

    default:
      return state;
  }
}

export const updateFeatureFlags = (
  cookies: Object = {},
  experiments: Seek$Experiments
) => (dispatch: Function) => {
  return dispatch({
    type: UPDATE_FEATURE_FLAGS,
    payload: {
      dynamicFlags: {
        homepageBanners: cookies.HOMEPAGE_BANNERS,
        appInstallNative: experimentsHelper(
          cookies.APP_INSTALL_NATIVE,
          appInstallNativeExperimentId,
          experiments
        ),
        cisClickToReveal: experimentsHelper(
          cookies.CIS_CLICK_TO_REVEAL,
          cisClickToRevealExperimentId,
          experiments
        ),
        retireDisplayAds: cookies.RETIRE_DISPLAY_ADS,
        isTabFeatureFlag: Boolean(cookies.TAB)
      }
    }
  });
};
